// extracted by mini-css-extract-plugin
export default {"counter":"Counter_counter__KU+Ld","active":"Counter_active__SgqM0"};